<template>
  <div class="mode">
    <i
      class="fa fa-moon-o"
      v-show="mixLayout == 'light-only'"
      @click="customizeMixLayout('dark-only')"
    ></i>
    <i
      class="fa fa-lightbulb-o"
      v-show="mixLayout == 'dark-only'"
      @click="customizeMixLayout('light-only')"
    ></i>
  </div>
</template>

<script>
export default {
  name: 'ModeView',
  data() {
    return {
      darkMode: false,
      mixLayout: 'light-only',
    }
  },
  created() {
    // Leer el modo guardado en localStorage o usar 'light-only' por defecto
    const savedMode = localStorage.getItem('themeMode') || 'light-only'
    this.mixLayout = savedMode
    // Aplicar el modo guardado al cargar el componente
    this.$store.dispatch('layout/setLayout', savedMode)
  },
  methods: {
    customizeMixLayout(val) {
      this.mixLayout = val
      // Guardar en localStorage
      localStorage.setItem('themeMode', val)
      // Aplicar el modo en el store
      this.$store.dispatch('layout/setLayout', val)
    },
  },
}
</script>
